import * as React from 'react'
import CancelSvg from '../Icons/General/Cancel'
import {
  CloseButton,
  ModalBackground,
  ModalWrapper,
} from './Modal.styles'

export enum Sizes {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

type ModalProps = {
  handleClose: () => void,
  isOpen: boolean,
  className?: string,
  size?: Sizes,
  children: React.ReactNode
}

const Modal = ({
  handleClose,
  isOpen,
  className = '',
  children,
  size,
}: ModalProps) => {
  if (!isOpen) return null

  return (
    <ModalBackground>
      <ModalWrapper className={className} size={size}>
        {children}
        <CloseButton onClick={handleClose} data-testid="modal-onClose">
          <CancelSvg />
        </CloseButton>
      </ModalWrapper>
    </ModalBackground>
  )
}

Modal.defaultProps = {
  className: undefined,
  size: Sizes.medium,
}

export default Modal
